import angular from 'angular';
import buscadorAvanzado from './buscador-avanzado/buscador-avanzado.component';

const MODULE_NAME = 'buscador.componentes';

const ngModule = angular.module(MODULE_NAME, [buscadorAvanzado]);

export default MODULE_NAME;


// WEBPACK FOOTER //
// ./src/busqueda/componentes/index.js